import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { REPORT_ARTICLE } from '../graphql/voting';
import { FiX, FiAlertCircle } from 'react-icons/fi';

const ReportModal = ({ isOpen, onClose, articleId, articleTitle }) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const [reportArticle] = useMutation(REPORT_ARTICLE, {
    onCompleted: (data) => {
      if (data.reportArticle.success) {
        setSuccess(true);
        setTimeout(() => {
          onClose();
          setSuccess(false);
          setReason('');
          setError('');
        }, 1500);
      } else {
        setError(data.reportArticle.message || '檢舉失敗');
        setIsSubmitting(false);
      }
    },
    onError: (error) => {
      setError(error.message || '檢舉失敗，請稍後再試');
      setIsSubmitting(false);
    }
  });

  const reportReasons = [
    { value: 'VIOLATES_LAW', label: '違反法律' },
    { value: 'FAKE_NEWS', label: '虛假消息' },
    { value: 'MEANINGLESS_OR_DUPLICATE', label: '無意義or明顯重複內容' },
    { value: 'WRONG_TAG', label: '標籤錯誤' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!reason) {
      setError('請選擇檢舉原因');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await reportArticle({
        variables: {
          articleId: articleId,
          reason: reason
        }
      });
    } catch (err) {
      // Error handled in onError callback
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setReason('');
      setError('');
      setSuccess(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 relative">
        {/* 關閉按鈕 */}
        <button
          onClick={handleClose}
          disabled={isSubmitting}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <FiX className="w-5 h-5" />
        </button>

        <div className="p-6">
          <div className="flex items-center mb-4">
            <FiAlertCircle className="w-6 h-6 text-red-500 mr-2" />
            <h2 className="text-xl font-bold text-gray-900">檢舉文章</h2>
          </div>

          {articleTitle && (
            <p className="text-sm text-gray-600 mb-4">
              文章：{articleTitle}
            </p>
          )}

          {success ? (
            <div className="text-center py-8">
              <div className="text-green-500 text-4xl mb-4">✓</div>
              <p className="text-lg font-medium text-gray-900">檢舉成功</p>
              <p className="text-sm text-gray-600 mt-2">感謝您的回報</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  檢舉原因 <span className="text-red-500">*</span>
                </label>
                <select
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  disabled={isSubmitting}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                >
                  <option value="">請選擇檢舉原因</option>
                  {reportReasons.map((r) => (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  ))}
                </select>
              </div>

              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-sm text-red-600">{error}</p>
                </div>
              )}

              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={handleClose}
                  disabled={isSubmitting}
                  className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50"
                >
                  取消
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting || !reason}
                  className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? '提交中...' : '提交檢舉'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportModal;

